export const STATUS_OPEN: string = 'open';
export const STATUS_PAID: string = 'paid';
export const STATUS_DEPOSITED: string = 'deposited';

export const STATUSES = [STATUS_OPEN, STATUS_PAID, STATUS_DEPOSITED];
